import { addDoc, collection, doc, setDoc } from "firebase/firestore";
import { db } from "../../firebase";
import HelperForMetaData from "../../Helpers/HelperForMetaData";

const CreateUserRecord = async (UserFinalObject, user, SchoolID) => {
  const record = {
    ...UserFinalObject,
    uid: user.uid,
    SchoolID: SchoolID,
    ...HelperForMetaData({}),
  };

  const UsersCollection = await collection(db, "Users");
  await setDoc(doc(UsersCollection, record.uid), record)
    .then((res) => true)
    .catch((err) => {
      console.log(err);
    });
};

export default CreateUserRecord;
